<ion-app>
  <tui-root>
    <ion-router-outlet></ion-router-outlet>
  </tui-root>
</ion-app>
